export const partnerAttachmentsTranslation = {
  content: {
    validation: {
      attachments: 'partnerinfo-content-validation-attachments',
    },
    blockTitles: {
      attachmentsBlock: 'partnerinfo-content-blocktitles-attachments_block',
    },
  },
}
